export const defaultAiAssistantInfo = {
	title: "Ai Learning Agent",
	alias: "AiLA",
	icon: "https://memorang-prod-media.s3.amazonaws.com/aila-default-icon.png",
	showOriginalQuestion: true,
	initialMessage:
		"Hey there! I'm {{alias}}, your {{title}}, and I'm here to help you better prepare for {{context}}. Let's take a closer look at the question you answered on {{topic}}.",
	initialAiMessage: {
		"en-US":
			"Hey there! I'm {{alias}}, your {{title}}, and I'm here to help you better prepare for {{context}}. Let's take a closer look at the question you answered on {{topic}}.",
		"zh-CN":
			"你好！我是 {{alias}}, 你的 {{title}}, 我在这里帮助你更好地准备 {{context}}。让我们仔细看看你在 {{topic}} 上回答的问题。",
		"ja-JP":
			"こんにちは！私は {{alias}}、あなたの {{title}} です！{{context}} の準備をより良くするためにお手伝いします。{{topic}} について回答した質問を詳しく見てみましょう。",
	},
};
